module.exports = __webpack_public_path__ + "static/media/ic_question_circle.cdf05fe4.svg";